import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import HeartIcon from '../../../assets/Player_Portal/images/heart-Icon.png';
import SkewCard from '../../../assets/Player_Portal/images/card-skew.png';
import CornerCircle from '../../../assets/Player_Portal/images/circle-corner.png';
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Loader from '../../../components/Loader/Loader';
import { useNavigate } from 'react-router-dom';
import { useVerifyMailMutation } from '../../../features/UserFeatures/VerifyMail/VerifyMailSlice';

const VerifyMail = () => {
// const navigate = useNavigate()
    const [verifyEmail] = useVerifyMailMutation()
const [loading, setLoading] = useState(false)
  const { register, handleSubmit, formState: { errors }, reset, } = useForm()
  const [state , setState]=useState(false)

//   const verifyUserEmail = async () => {
//     console.log("verifyUserEmailcalled");
//     const data = await verifyEmail();
//       console.log("datadatadatadatadata",data);
//   }
 

  const onSubmit = async (data) => {
    setLoading(true)

    console.log("verifyUserEmailcalled",data);
    const verifyEmails = await verifyEmail(data);
      console.log("datadatadatadatadata",verifyEmails);

    try {
        // console.log("verifyUserEmailcalled");
        // const data = await verifyEmail();
        //   console.log("datadatadatadatadata",data);

      if (verifyEmails?.data?.status === 200) {
        localStorage.setItem("forgotEmail", verifyEmail?.data?.data?.email)
        Swal.fire({
          title: 'Success',
          type: 'success',
          text: verifyEmails?.data?.message,
        });
        reset({email : ""})
        setState(true)
      }
      else{
        Swal.fire({
          title: 'Warning',
          type: 'warning',
          text: verifyEmails?.data?.message,
        });
      }
    }
    catch (err) {
      Swal.fire({
        title: 'Error',
        type: 'Error',
        text: err,
      });
    }
    setLoading(false)
}

return (

  <div className='formWrapper'>
      {loading && <Loader />}
    <Container fluid className='h-100'>
      <Row className='h-100'>
        <Col xs={7} className='forgotBg p-0'>
          <div className='d-flex flex-column justify-content-between h-100'>
            <div className='text-end'>
              <img src={HeartIcon} alt="Heart Image"/>
            </div>
            <div className='text-start'>
              <img src={SkewCard} alt="Card Image"/>
            </div>
            <div className='text-start'>
              <img src={CornerCircle} alt="Corner Circle"/>
            </div>
          </div>
        </Col>


     

       <Col>
       <div className='loginForm'>

         <form onSubmit={handleSubmit(onSubmit)} className="form-md">
           <h4 className='welcomeText text-start mb-3'>Resend Verification Link!</h4>
           <p className='loginPara text-start mb-4'>Enter your Registered email address.</p>
           <div className="form-group mb-5">
             <input
               id="email" type="email" name="email"
               {...register("email", { required: "*Please enter a valid email.", pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Please enter a valid Email Pattern."
            }, })} placeholder='E-mail'
             />
             <span className='inputIcon'>
               <svg xmlns="http://www.w3.org/2000/svg" width="24.718" height="17.725" viewBox="0 0 25.718 20.725">
                 <path id="mail-svgrepo-com" d="M23.978,6.74c-1.8-1.628-4.838-2.24-9.619-2.24S6.542,5.112,4.74,6.74m19.238,0c1.616,1.46,2.24,3.737,2.24,7.122,0,7.159-2.79,9.362-11.859,9.362S2.5,21.022,2.5,13.862c0-3.385.624-5.662,2.24-7.122m19.238,0-7.853,7.853a2.5,2.5,0,0,1-3.531,0L4.74,6.74" transform="translate(-1.5 -3.5)" fill="none" stroke="#989898" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
               </svg>
             </span>
             {/* <label className='customLabel' htmlFor="email">email</label> */}
             {errors.email && <span role="alert">{errors.email.message}</span>}
           </div>
           <button className='btn btnSubmit mt-2' type="submit" >SUBMIT</button>
         </form>
       </div>
     </Col> 
      </Row>
    </Container>
  </div>
);
}

export default VerifyMail;
